import { Observable, of } from "rxjs";
import { delay } from "rxjs/operators";
import { uuid } from "src/app/support/uuid";
import { Paginated } from "src/app/support/paginated";
import { Facility } from "../models/facility";

export class FacilityBackend {
  load(): Observable<Facility> {
    return of(MOCK_DATA[0]).pipe(delay(250));
  }

  list(): Observable<Paginated<Facility>> {
    return of({
      list: MOCK_DATA,
      count: MOCK_DATA.length
    }).pipe(delay(250));
  }

  getLogo(input: any): Observable<any> {
    return of(<any>{
      getFacilityLogo: {
        url: "/assets/images/demo/pomezia.png"
      }
    });
  }
}

const MOCK_DATA: Facility[] = [
  {
    uuid: "12345",
    administrator: "Ugo Verdi",
    businessName: "Clinica Veterinaria Miramare",
    nation: "Italia",
    isActive: true,
    isSoftDeleted: false,
    practiceUuid: uuid(),
    address: {
      address: "Via Roma 1",
      city: "Milano",
      zipCode: "10100",
      state: "MI",
      country: "Italia"
    },
    spokenLanguages: ["Italiano", "Inglese"],
    social: [],
    phone: [
      {
        phone: "34568968696"
      },
      {
        phone: "495849545894"
      }
    ],
    email: [
      {
        email: "info@clinica.com"
      },
      {
        email: "support@clinica.com"
      }
    ],
    timetable: {
      isH24: true,
      isNightShiftAvailable: true,
      daysOfWeek: [
        {
          day: 0,
          isActive: true,
          timeSlot: [
            {
              startTime: "08:00",
              endTime: "13:00"
            },
            {
              startTime: "14:00",
              endTime: "20:00"
            }
          ]
        },
        {
          day: 1,
          isActive: true,
          timeSlot: [
            {
              startTime: "08:00",
              endTime: "13:00"
            },
            {
              startTime: "14:00",
              endTime: "20:00"
            }
          ]
        },
        {
          day: 2,
          isActive: true,
          timeSlot: [
            {
              startTime: "08:00",
              endTime: "13:00"
            },
            {
              startTime: "14:00",
              endTime: "20:00"
            }
          ]
        },
        {
          day: 3,
          isActive: false,
          timeSlot: []
        },
        {
          day: 4,
          isActive: false,
          timeSlot: []
        },
        {
          day: 5,
          isActive: false,
          timeSlot: []
        },
        {
          day: 6,
          isActive: false,
          timeSlot: []
        }
      ]
    },
    services: [
      {
        name: "Servizio 1"
      },
      {
        name: "Servizio 2"
      }
    ],
    wards: [{ name: "Reparto 1" }, { name: "Reparto 2" }]
  },
  {
    uuid: "54321",
    administrator: "Mario Rossi",
    businessName: 'Clinica Veterinaria "Lo Scoglio"',
    nation: "Italia",
    isActive: true,
    isSoftDeleted: false,
    practiceUuid: uuid(),
    address: {
      address: "Via Roma 1",
      city: "Milano",
      zipCode: "10100",
      state: "MI",
      country: "Italia"
    },
    spokenLanguages: ["Italiano", "Inglese"],
    social: [],
    phone: [],
    email: [],
    services: [
      {
        name: "Servizio 1"
      },
      {
        name: "Servizio 2"
      }
    ],
    wards: [{ name: "Reparto 1" }, { name: "Reparto 2" }]
  },
  {
    uuid: "32321",
    administrator: "Pino Giallo",
    businessName: "Clinica Veterinaria Faudo",
    nation: "Italia",
    isActive: false,
    isSoftDeleted: false,
    practiceUuid: uuid(),
    address: {
      address: "Via Roma 1",
      city: "Milano",
      zipCode: "10100",
      state: "MI",
      country: "Italia"
    },
    spokenLanguages: ["Italiano", "Inglese"],
    social: [],
    phone: [],
    email: [],
    services: [
      {
        name: "Servizio 1"
      },
      {
        name: "Servizio 2"
      }
    ],
    wards: [{ name: "Reparto 1" }, { name: "Reparto 2" }]
  }
];
